@if (isVisible) {
  <div>
    <div class="ag-filter-body" ref="eCondition1Body" >
      <p-listbox #setFilterListbox [options]="inputvalues" [(ngModel)]="selectedvalues" multiple="multiple" checkbox="checkbox" filter="filter" resetFilterOnHide="true" (keydown)="onKeydown($event)">
      </p-listbox>
    </div>
    <div class="ag-filter-apply-panel" ref="eButtonsPanel">
      <button type="button" ref="eClearButton" (click)="onClearAction()">Clear</button>
      <button type="button" ref="eApplyButton" (click)="onApplyAction();"  >Apply</button>
    </div>
  </div>
}

